import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
export function transformSize(size) {
  if (size > 1024 * 1024) {
    return "".concat((size / (1024 * 1024)).toFixed(1), "GB");
  }

  return "".concat((size / 1024).toFixed(1), "MB");
}
export function transformDownloadCount(downloadCont) {
  if (!downloadCont) {
    return downloadCont;
  }

  var length = downloadCont.toString().length;

  if (length > 8) {
    return "".concat((downloadCont / 100000000).toFixed(1), "\u4EBF");
  } else if (length > 4) {
    return "".concat((downloadCont / 10000).toFixed(1), "\u4E07");
  } else {
    return "".concat(downloadCont);
  }
}